import { Button, Form, Input, Row, Col } from 'antd';
import React, { useEffect } from 'react'
import { Add_FoodPrice_Api, Update_FoodPrice_Api } from '../../API/FoodPriceApi';
import { CheckOutlined, SaveOutlined } from '@ant-design/icons';

// =================================================================
export const EditFoodPricesDetailsComponent = ({
    setLoading,
    showMessage,
    foodPriceValues }) => {
    // =================================================================
    const [form] = Form.useForm();
    // =================================================================
    useEffect(() => {
        loadData()
    }, [foodPriceValues.id]);
    // =================================================================
    const loadData = async () => {

        if (foodPriceValues.id === "undefined")
            foodPriceValues.id = "0";
        if (foodPriceValues.price === "undefined")
            foodPriceValues.price = "";
        form.setFieldsValue(foodPriceValues);
    }
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            values.isActive = true;
            let data;
            if (values.id == 0) {
                data = await Add_FoodPrice_Api(values);

                foodPriceValues.id = parseInt(data.additional);
                foodPriceValues.price = values.price;
                form.setFieldsValue(foodPriceValues);
            }
            else
                data = await Update_FoodPrice_Api(values);


            setLoading(false);

            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful")
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // ===============================================================
    return (

        <Form
            form={form}
            name={"form" + foodPriceValues.id}
            onFinish={onSubmit}
            onFinishFailed={onFinishFailed}
        >
            <Row style={{ margin: '3px 0px' }}>

                <Col xs={6} sm={6} md={6} lg={6} xl={6} >
                    <Form.Item
                        name="foodTitle"
                        style={{ marginBottom: '0px', marginLeft: '5px' }}
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input className='noBorder' style={{ backgroundColor: 'transparent' }} readOnly={true} />
                    </Form.Item>
                </Col>
                <Col xs={12} sm={14} md={14} lg={14} xl={14}>
                    <Form.Item
                        name="price"
                        style={{ marginBottom: '0px' }}
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='مقدار' />
                    </Form.Item>
                </Col>
                <Col xs={6} sm={4} md={4} lg={4} xl={4} style={{ marginTop: '5px', textAlign: 'left' }}>
                    <Button className='btn-primary' htmlType="submit" style={{ width: '98%' }}>
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>


                <Form.Item
                    name="id"
                    hidden={true}
                >
                </Form.Item>

                <Form.Item
                    name="foodId"
                    hidden={true}
                >
                </Form.Item>


                <Form.Item
                    name="foodPricePeriodTitle"
                    hidden={true}
                >
                </Form.Item>
                <Form.Item
                    name="foodPricePeriodId"
                    hidden={true}
                >
                </Form.Item>
            </Row>

        </Form>

    )
}
